// extracted by mini-css-extract-plugin
export default {"container":"SortingList_container__oTxmD","list":"SortingList_list__ua0Ak"};